import { PolicyPage } from "@/components/PolicyPage";

/**
 * /refund-policy — public page rendered from the seeded
 * `policy_versions` row with `policy_type=refund_policy`. Uses the
 * same PolicyPage component that /terms and /privacy use, so version
 * number + effective date + markdown rendering are consistent.
 *
 * Linked from:
 *   - Plans page trust footer refund paragraph
 *   - Plans page trust footer terms paragraph
 *   - Per-card renewal/cancellation block on paid cards
 *   - Settings "Your access" section
 *   - AppShell global footer
 */
export default function RefundPolicy() {
  return (
    <PolicyPage
      policyType="refund_policy"
      title="Refund & Cancellation Policy"
      testid="refund-policy-page"
    />
  );
}
